export default class ConnectionWindow {
    window;

    popupWindow;

    popupWindowWatcher;

    popupWindowListener;

    constructor({window}) {
        this.window = window;
    }

    sendRequest({url}) {
        return new Promise((resolve, reject) => {
            // Open popup immediately to prevent it from being blocked by the browser.
            this.popupWindow = this.window.open(url, '_blank', `height=660px, width=660px`);

            this.popupWindowListener = (message) => {
                // Ignore messages from another components
                if (message.origin !== this.window.location.origin
                    // Vue dev tools conflicts sends a message from same origin
                    // so we also have to validate props
                    || !(message.data.scope || message.data.error)) {
                    return;
                }

                this.close();

                if (message.data.error) {
                    reject(new Error(message.data.error));
                } else {
                    resolve(message.data);
                }
            };

            this.window.addEventListener('message', this.popupWindowListener, false);

            // Watch if window is closed by user remove message listener.
            this.popupWindowWatcher = this.window.setInterval(() => {
                if (this.popupWindow && this.popupWindow.closed) {
                    // Send error message to listener, in this way close window,
                    // unsubscribe the listener and remove watcher.
                    this.popupWindowListener({
                        origin: this.window.location.origin,
                        data: {
                            error: 'The connection process failed. Please try again or contact support.',
                        },
                    });
                }
            }, 1000);
        });
    }

    receiveResponse(data) {
        this.window.opener.postMessage({...data}, this.window.opener.location.origin);
    }

    close() {
        // Before close the window, need to remove watcher.
        if (this.popupWindowWatcher) {
            this.window.clearInterval(this.popupWindowWatcher);
        }
        if (this.popupWindowListener) {
            this.window.removeEventListener('message', this.popupWindowListener);
        }
        if (this.popupWindow) {
            this.popupWindow.close();
        }
    }
}
